angular.module("app").factory('ProductGroupService', function($resource, apiUrl, resourceInterceptor) {
    return $resource(apiUrl + "/productGroup/:id", { id: "@id" }, {
        search: {
            url:apiUrl+'/productGroup/cms/gets',
            method: "GET",
            interceptor: resourceInterceptor
        },
        add: {
            method: "POST",
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            interceptor: resourceInterceptor
        },
        get: {
            method: "GET",
            interceptor: resourceInterceptor
        },
        edit: {
            method: "PUT",
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            interceptor: resourceInterceptor
        }
    });

})
